// Short random ids for anything new: assets, states, poses, scenes, shots, events.
export const uid = (prefix: string) => prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
